<template>
  <Modal ref="modalRef" :width="width" @after-close="emit('afterClose')">
    <template #body>
      <View direction="column" gap="sm" padding-block="sm">
        <Text variant="h4">{{ title }}</Text>
        <Text variant="body-medium" color="secondary">{{ description }}</Text>
      </View>
    </template>
    <template #footer>
      <Button variant="ghost" size="medium" @click="close">{{ cancelLabel }}</Button>
      <Button size="medium" :loading="loading" @click="emit('confirm')">{{ confirmLabel }}</Button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import Button from './button/button.vue';
import Modal from './modal.vue';
import Text from './text.vue';
import View from './view/view.vue';

withDefaults(
  defineProps<{
    title: string;
    description: string;
    confirmLabel: string;
    cancelLabel?: string;
    loading?: boolean;
    /** Narrow by default, for a one-line question; a page whose other dialogs are wider passes theirs */
    width?: string;
  }>(),
  { cancelLabel: 'Cancel', loading: false, width: '21rem' },
);

// Confirming stays the caller's move (async work, promise resolution); only Cancel closes here
const emit = defineEmits<{ confirm: []; afterClose: [] }>();

const modalRef = ref<InstanceType<typeof Modal>>();

function show() {
  modalRef.value?.show();
}

function close() {
  modalRef.value?.close();
}

defineExpose({ show, close });
</script>
